export default __webpack_public_path__ + "static/media/closet5-before3.182e2622.jpg";